var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "console-wrap" },
      [
        _c(
          "div",
          { class: { "console-header": true, nbd: _vm.isConsoleHome } },
          [
            _c("div", { staticClass: "con-box" }, [
              _c(
                "div",
                { staticClass: "account", staticStyle: { display: "flex" } },
                [
                  _c("div", { staticClass: "flex-b nw" }, [
                    _c("img", {
                      staticClass: "photo",
                      attrs: {
                        src: _vm.currentAuthUser.imgPath
                          ? _vm.fileOperShow(_vm.currentAuthUser.imgPath)
                          : "",
                        onerror: "this.src='/images/web/login_user_icon.png'"
                      }
                    }),
                    _c("div", { staticClass: "moreInfo" }, [
                      _vm.currentAuthUser.userStemFrom === -16 &&
                      !_vm.isInDingTalk
                        ? _c("img", {
                            staticStyle: {
                              width: "20px",
                              height: "20px",
                              "margin-right": "0"
                            },
                            attrs: { src: "/images/icon/dingIcon.png", alt: "" }
                          })
                        : _vm._e(),
                      _c("img", {
                        staticStyle: { "max-height": "28px" },
                        attrs: {
                          src: require("../static/images/ywt_logo.png"),
                          alt: ""
                        }
                      }),
                      _c("span", { staticClass: "name" }, [
                        _vm._v(
                          "（" + _vm._s(_vm.corpName.substring(0, 5)) + "）"
                        )
                      ])
                    ]),
                    _c("i", {
                      staticClass: "el-icon-caret-bottom",
                      staticStyle: { "font-size": "24px" }
                    })
                  ]),
                  _c(
                    "div",
                    { staticClass: "comp-expand" },
                    [
                      _c("change-account", {
                        attrs: {
                          users: _vm.consoleUsers,
                          ywtAccountChoose: true,
                          lineHeight: 59
                        },
                        on: { showExpandIcon: _vm.showExpandIcon }
                      })
                    ],
                    1
                  )
                ]
              ),
              _c(
                "div",
                {
                  staticStyle: {
                    display: "flex",
                    "justify-content": "flex-end"
                  }
                },
                [
                  _c(
                    "ul",
                    _vm._l(_vm.endConsoleMenus, function(item, index) {
                      return _c(
                        "li",
                        {
                          key: index,
                          class: { active: _vm.menuActive === item.value },
                          attrs: { id: "menu" + index },
                          on: {
                            click: function($event) {
                              return _vm.toYwtMenusFn(item)
                            }
                          }
                        },
                        [_c("span", [_vm._v(_vm._s(item.name))])]
                      )
                    }),
                    0
                  ),
                  _c(
                    "div",
                    { staticClass: "ls-sh" },
                    [
                      _c(
                        "el-button",
                        { staticClass: "backBZ", on: { click: _vm.turnBack } },
                        [_vm._v("返回首页")]
                      )
                    ],
                    1
                  )
                ]
              )
            ])
          ]
        ),
        _c("nuxt", { ref: "nuxtPageRef" })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6c516988", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c516988","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./layouts/ywtLayout.vue
// module id = +Bmj
// module chunks = 153